import { useContactLensProductData } from '../../../../context/product-context-hooks.js';
import { useCLEcommContext } from '../context/CLEcommContext.js';

const useGetCLLoyaltyPoints = ()=>{
    const { displayPrice: { loyaltyPoints  } ,  } = useContactLensProductData();
    const { state , selectors  } = useCLEcommContext();
    // If there is no selected quantity, i.e. both columns are disabled, default to 1
    const totalSelectedQuantity = selectors.getEnabledSelectedQuantity(state) || 1;
    return loyaltyPoints && loyaltyPoints * totalSelectedQuantity;
};

export { useGetCLLoyaltyPoints };
//# sourceMappingURL=use-get-cl-loyalty-points.js.map
